module.exports = __webpack_public_path__ + "static/media/hotpins1.6ca62aeb.jpg";